import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationStoreService {

  constructor() { }

  notify: Subject<any> = new Subject<any>();
  onNotify(arg: any) {
    this.notify.next(arg);
  }

  sessionUpdate: Subject<boolean> = new Subject<boolean>();
  onsessionUpdate(arg: any) {
    this.sessionUpdate.next(arg);
  }

  mapNotifity: Subject<boolean> = new Subject<boolean>();
  mapNotifityUpdate(arg: any) {
    this.mapNotifity.next(arg);
  }

  mapEmployeeNotifity: Subject<boolean> = new Subject<boolean>();
  mapEmployeeNotifityUpdate(arg: any) {
    this.mapEmployeeNotifity.next(arg);
  }

  clearNotificationsNotify: Subject<boolean> = new Subject<boolean>();
  onClearNotificationsNotify(arg: any) {
    this.clearNotificationsNotify.next(arg);
  }
}
